import styled from "@emotion/styled";
import React from "react";
import { usePopupContext } from "../../contexts/PopupContext/context";

interface IProps {
  popupWidth?: string | number;
}

const Wrapper = styled("div", {
  shouldForwardProp: (prop) => {
    const customPropKeys: PropertyKey[] = ["open", "popupWidth"];
    return !customPropKeys.includes(prop);
  },
})<{
  open?: boolean;
  popupWidth?: string | number;
}>(({ theme, open, popupWidth }) => ({
  flexGrow: 1,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: `calc(100% - ${popupWidth}px)`,
  }),
}));

export const PlacementWorksheetRightPopupWrapper: React.FC<IProps> = (props) => {
  const { children, popupWidth } = props;
  const { isRightOpen } = usePopupContext();
  return (
    <Wrapper open={isRightOpen} popupWidth={popupWidth}>
      {children}
    </Wrapper>
  );
};
